import React from 'react';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';


const ProgressLine = (props) => {
    return (
        <div className='ProgressLine'>
            <div className='progress-color' style={{width: props.percent + '%'}}></div> 
        </div>

    );
};
export default ProgressLine;
